<template>
    <div class="leval">
        <my-header></my-header>
        <!-- 导航 -->
        
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" ><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <el-row class="msg" >
            <el-col :span="2"><div>&nbsp;</div></el-col>
            <el-col :span="20" :xs="{span:20}" :sm="{span:20}" :md="{span:20}">
                <el-col :span="2" class="leval_left hidden-xs-only" >
                    <ul>
                        <span><i class="el-icon-s-custom"></i> 服务中心</span>
                        <li v-for="(list,index) in rightList" :key="index" 
                            @click="change(index)" 
                            :class="{num : changes == index }" 
                            v-on:mouseover="changeActive($event)" 
                            v-on:mouseout="removeActive($event)"
                        ><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                    </ul>
                </el-col>
                <el-col v-if="showSee">
                    <div class="md_fwzx">
                        <ul>
                            <span><i class="el-icon-s-custom"></i>服务中心</span>
                            <li v-for="(list,index) in rightList" :key="index" @click="change(index)" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)"><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="18" class="leval_right" >
                    <div v-if="changes == 0" >
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与俄罗斯莫斯科、圣彼得堡、叶卡捷琳堡和克拉斯诺达尔等地区的知名律师事务所，知名律师签有合作互助协议。由这些律师事务所进行投资项目风险评估、起草、设计和制作可行性报告，投资文件，办理企业注册登记，许可证，同时，负责投资方案优化，合理安排投资结构，税收体系。在企业经营过程中，协助处理债务纠纷、投资纠纷和破产清算等法律事务。对于某些刑事案件提供法律援助，建立联保机制，维护个人和企业的合法权益不受侵犯。</p>
                        </div>
                        <!-- 律师 -->
                        <div class="lawyer">
                            <span>律师</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul v-for="(list,n) in Lawyer" :key="n" @click="lawDetail(list)">
                                <li><img :src="list.picture" alt="律师图片"></li>
                                <h3 class="lawyer_name">姓名:{{list.name}}</h3>
                                <li class="lawyer_phone"><i class="el-icon-user"></i> {{list.phonenum}}</li>
                                <li style="text-align:right;color:#409EFF">查看详情></li>
                                <!-- <li class="lawyer_dis">简介:{{list.discribe}}</li> -->
                            </ul>
                        </div>
                        <!-- 律师详情 -->
                        <el-dialog title="详细信息" :visible.sync="dialogFormVisible" >
                            <div style="float:left;width:50%;">
                                <img :src="lawObj.picture" disabled width="100%;" height="220" style="display:block;">
                            </div>
                            <div style="float:left;width:50%;">
                                <div> <span>{{lawObj.name}}</span></div>
                                <div> <span>{{lawObj.phonenum}}</span></div>
                            </div>
                            <div style="clear:both"></div>
                            <div>
                                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{lawObj.discribe}}</div>
                            </div>
                        </el-dialog>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in lawyerOfficial" :key="m">
                                    <li ><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}  </li>
                                    <li class="off_time"><i class="el-icon-time"></i> {{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">>></li> -->
                                </ul>
                                <ul v-if="lawyerOfficial.length == 0"> 
                                    <li>当前暂无内容</li>
                                </ul>
                            </div>
                            
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in lawMember" :key="k" 
                                    @click="artDetails(item.id)" 
                                    v-on:mouseover="changeList($event)" 
                                    v-on:mouseout="removechange($event)" > 
                                    <p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p>
                                    <strong v-if="item.top == 0">置顶</strong> {{item.title}}
                                    
                                    <span style="float:right">{{item.addtime}}</span> 
                                </li>
                                <li v-if="lawMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 1">
                        <!-- 物流 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与中国中远物流集团达成战略合作协议，在联合会框架内，为联合会会员提供海运，铁路，空运，海铁联运服务。会员不仅享有优惠的运输价格，而且，在联合会的担保下，可以享受50-75天的运费延期付款账期。 </p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in logOfficial" :key="m">
                                    <!-- <li><span v-if="logOfficial.length == 0">当前暂无内容</span></li> -->
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}} </li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="logOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                
                                <li v-for="(item,k) in logMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="logMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 2">
                        <!-- 金融 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与俄罗斯团结银行、俄罗斯阿尔法银行和俄罗斯开放银行有密切的合作关系。并且这几家银行在联合会框架内，为联合会会员提供开户、账户流转服务、开立交易许可证服务、开立信用证服务、开立银行保函服务、项目投资和贸易融资服务（包括设备租购合一服务、周转贷款服务、设备，货物延期付款服务），同时，通过与当地银行建立投融资关系也可以达到财产保全的目的。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in finOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}} </li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="finOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in finMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="finMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 3">
                        <!-- 租赁 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;闲置设备、工具、车辆、厂房、仓库和技术人员共享。联合会网站的会员有发布消息权限，能够发布闲置物品的出租，出售信息。联合会会员共享这些资源，盘活资源，节约资金。</p>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与中国知名的第三方检测，监造公司签署合作协议，可以为联合会会员提供设备，货物制造，发运等等各个环节的监造，检测服务，享有50%以上的价格优惠。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in leaseOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}} </li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="leaseOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in leaMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="leaMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 4">
                        <!-- 展会 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;定期组织中俄不同行业的企业家峰会，交流信息，沟通合作；组织在俄投资企业成果展览。</p>
                            <!-- <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与中国知名的第三方检测，监造公司签署合作协议，可以为联合会会员提供设备，货物制造，发运等等各个环节的监造，检测服务，享有50%以上的价格优惠。</p> -->
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in expoOfficial" :key="m" >
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="expoOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in expoMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="expoMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 5">
                        <!-- 商务 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;协助组织与中国各部，各省商务厅与联合会会员交流，协调，组织，安排企业，个人与俄罗斯各地方政府部门对接，交流；协助安排企业集团，个人的商务考察，咨询。提供全程食宿，车辆服务。安排与有经验，有实际投资的企业或个人交流信息，参观考察实体。</p>
                            <!-- <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会与中国知名的第三方检测，监造公司签署合作协议，可以为联合会会员提供设备，货物制造，发运等等各个环节的监造，检测服务，享有50%以上的价格优惠。</p> -->
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in affOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="affOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in affMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="affMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 6">
                        <!-- 翻译 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;投资文件翻译，公证，认证；投资文件，设备图纸，说明书，使用手册，产品介绍视频，音频文件，PPT制作；欧亚联盟针对不同设备，物品所需认证，许可证书办理；俄文，英文版本均可。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in tranOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="tranOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in tranMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="tranMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 7">
                        <!-- 人才 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人才交流，新技术，新发明成果转化。技术找资金，资金找技术。中俄各企业人才交流，介绍。</p>
                        </div>
                         <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in personOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="personOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in personMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="personMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 8">
                        <!-- 慈善 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;赞助，配合两国文化，艺术交流。开展慈善，回馈社会，改变中国企业形象。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in charOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布" ></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="charOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in charMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="charMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div> 
                    </div>
                    <!-- <div v-if="changes == 9"> -->
                        <!-- 一带一路 -->
                        <!-- <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中俄战略合作伙伴关系宣传；一带一路政策宣传。中俄海关、税务、移民和劳动等领域政策培训，讲解，更新提醒，政策导向分析。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in roadOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                </ul>
                                <div v-if="roadOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in roadMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="roadMember.length == 0">当前暂无内容</li>
                            </ul>
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div> -->
                    <!-- </div> -->
                    <div v-if="changes == 9">
                        <!-- 互助基金 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;设立互助基金，从基金中给予项目资金支持；对于某些遭受损失的企业或个人给予援助，补偿；保险、紧急、突发事件互助，处理。 </p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in culOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="culOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in culMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="culMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 10">
                        <!-- 财务管理 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与俄罗斯知名审计、财务公司合作，在联合会框架内，共享资源，节省费用。对项目，合作伙伴进行审计、考察、调查和评估。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in financeOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="financeOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in finanMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="finanMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 11">
                        <!-- 政策 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中俄战略合作伙伴关系宣传；一带一路政策宣传。中俄海关、税务、移民和劳动等领域政策培训，讲解，更新提醒，政策导向分析。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in policyOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="policyOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in finanMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="finanMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes == 12">
                        <!-- 投融资项目公示 -->
                        <div class="project">
                            <span class="project_item">项目简介</span>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会会员可以在该网站发布与投资、融资、寻找合作伙伴、场地厂房、设备和人员的有关信息，用于交流，对接。</p>
                        </div>
                        <div class="official">
                            <span>官方发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <div class="listgffb">
                                <ul v-for="(list,m) in projectOfficial" :key="m">
                                    <li><img :src="list.picture" alt="官方发布"></li>
                                    <li class="off_title"><span v-if="list.top == 0" class="top">置顶</span> {{list.title}}</li>
                                    <li class="off_time"><i class="el-icon-time"></i>{{list.addtime}}</li>
                                    <li class="off_msg">{{list.textinfo}}</li>
                                    <el-button type="warning" @click="artDetails(list.id)">查看详情</el-button>
                                    <!-- <li @click="artDetails(list.id)">查看详情>></li> -->
                                </ul>
                                <div v-if="projectOfficial.length == 0">
                                    <div>当前暂无内容</div>
                                </div>
                            </div>
                        </div>
                        <div class="memuse">
                            <span>会员发布</span>
                            <span style="width:100%;height:1px;background-color:#ccc"></span>
                            <ul>
                                <li v-for="(item,k) in proMember" :key="k" @click="artDetails(item.id)" v-on:mouseover="changeList($event)" v-on:mouseout="removechange($event)"><p v-if="k<3" style="display:inline-block;color:#fe9900;">最新</p><strong v-if="item.top == 0">置顶</strong> {{item.title}} <span style="float:right">{{item.addtime}}</span></li>
                                <li v-if="proMember.length == 0">当前暂无内容</li>
                            </ul>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="page"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-col>
            <el-col :span="2"><div>&nbsp;</div></el-col>
        </el-row>
        <my-footer></my-footer>
        <!-- <template v-if="changeRed == 0">
            <my-home></my-home>
        </template>
        <template v-if="changeRed == 1">
            <my-leval></my-leval>
        </template>
        
        <template v-if="changeRed == 2">
            <my-member></my-member>
        </template> -->
    </div>
</template>

<script>
import MyHeader  from '../headerPage'
import MyFooter  from '../footerPage'
import MyMember from '@/components/ZH-CN/memberPage'
import MyLeval from '@/components/ZH-CN/jjgkPage'

import MyHome from '@/components/ZH-CN/homePage'

export default {
    components:{ MyHeader,MyMember,MyHome,MyLeval,MyFooter},
    data(){
        return{
            dialogFormVisible:false,
            lawObj:{},
            changeRed:0,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
            rightList:[{
                text:'法律事务'
            },{
                text:"物流服务"
            },{
                text:"融资投资"
            },{
                text:"租赁共享"
            },{
                text:"峰会展览"
            },{
                text:"商务考察"
            },{
                text:"翻译公证"
            },{
                text:"人才交流"
            },{
                text:"慈善文化"
            },{
                text:"互助基金"
            },{
                text:"财务管理"
            },{
                text:"政策宣传"
            },{
                text:"投融资项目公示"
            }],
            changes:this.$route.params.changes-1 || 0,
            Lawyer:[], //律师
            lawyerOfficial:[],   //律师官方发布 
            lawMember:[],  //律师会员发布
            page:1,
            pageSize:10,
            total:0,
            logOfficial:[], //wuliu
            logMember:[],
            finOfficial:[],  // jinrong 
            finMember:[],
            leaseOfficial:[], //租赁
            leaMember:[],
            expoOfficial:[],  //展会
            expoMember:[],
            affOfficial:[], //商务
            affMember:[],
            tranOfficial:[], //翻译
            tranMember:[],
            personOfficial:[],  //人才
            personMember:[],
            charOfficial:[],  //慈善
            charMember:[],
            // roadOfficial:[], // 一带一路
            // roadMember:[],
            culOfficial:[],  //互助基金 官方
            culMember:[],   //互助基金  会员
            policyOfficial:[],  //政策宣传  官方
            polMember:[],
            financeOfficial:[], //财务官方
            finanMember:[],  //财务会员
            showSee:false,

            proMember:[],
            projectOfficial:[]
        }
    },
    mounted() {
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showSee = true
        }else{
            this.showSee = false
        }
        this.lawyer();
        this.lawyerOff();
        this.lawyerMember();
        this.logisOff();  //物流官方
        this.logisMember();
        this.financeOff();   //金融官方
        this.financeMember();
        this.leaseOff();
        this.leaseMember();
        this.exhibitOff();
        this.exhibitMember();
        this.assistanceOff();
        this.assistanceMember();
        this.tranOff();
        this.translateMember();
        this.personOff();
        this.personnelMember();
        this.charOff();
        this.charitableMember();
        //this.theOff();
        //this.theMember();
        this.culOff();
        this.cultureMember();
        this.polOff();
        this.policyMember();

        this.projectMember();
        this.projectOff();

        this.finesOfficial(); //财务官方
        this.finesMember();  //财务会员
    },
    beforeCreate() {
        this.changes=this.$route.params.changes
    },
    updated() {
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showSee = true
        }else{
            this.showSee = false
        }
    },
    methods: {
        // 服务中心列表移入事件
        changeActive($event){
            $event.currentTarget.classList.add("active");
        },
        //服务中心列表移出
        removeActive($event){
            $event.currentTarget.classList.remove("active");
        },
        //移入事件
        changeList($event){
            $event.currentTarget.className="change"
        },
        //移出
        removechange($event){
             $event.currentTarget.className="";
        },
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
        change(index){
            this.changes = index;
        },
        //律师
        lawyer(){
            this.$axios.get("/getLawyers").then(res=>{
                this.Lawyer = res.data.data
            })
        },
        //律师官方发布内容
        lawyerOff(){
            this.$axios.get('/getOfficials/LAW').then(res=>{
                this.lawyerOfficial =res.data.data;
            })
        },
        //分页
        currentChange(page){
            this.page = page
            this.lawyerMember();
        },
        //律师  会员发布
        lawyerMember(){
            this.$axios.get('/getMemberInfos/LAW/'+this.page+'/'+this.pageSize).then(res=>{
                // console.log(res);
                this.total = res.data.data.total;
                this.lawMember = res.data.data.list
            })
        },
        //物流官方
        logisOff(){
            this.$axios.get('/getOfficials/LOGISTICS').then(res=>{

                this.logOfficial =res.data.data;
            })
        },
        // 物流会员
        logisMember(){
            this.$axios.get('/getMemberInfos/LOGISTICS/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.logMember = res.data.data.list
            })
        },
        // 金融官方
        financeOff(){
            this.$axios.get('/getOfficials/FINANCE').then(res=>{

                this.finOfficial =res.data.data;
            })
        },
        //金融 会员
        financeMember(){
            this.$axios.get('/getMemberInfos/FINANCE/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.finMember = res.data.data.list
            })
        },
        // 租赁 官方
        leaseOff(){
            this.$axios.get('/getOfficials/LEASE').then(res=>{

                this.leaseOfficial =res.data.data;
            })
        },
        //租赁 会员
        leaseMember(){
            this.$axios.get('/getMemberInfos/LEASE/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.leaMember = res.data.data.list
            })
        },
        //展会 官方
        exhibitOff(){
            this.$axios.get('/getOfficials/EXHIBTION').then(res=>{

                this.expoOfficial =res.data.data;
            })
        },
        //展会 会员
        exhibitMember(){
            this.$axios.get('/getMemberInfos/EXHIBTION/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.expoMember = res.data.data.list
            })
        },
        //商务 官方
        assistanceOff(){
            this.$axios.get('/getOfficials/BUSINESS').then(res=>{

                this.affOfficial =res.data.data;
            })
        },
        //商务 会员
        assistanceMember(){
            this.$axios.get('/getMemberInfos/BUSINESS/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.affMember = res.data.data.list
            })
        },
        // 翻译 官方
        tranOff(){
            this.$axios.get('/getOfficials/TRANSLATE').then(res=>{

                this.tranOfficial =res.data.data;
            })
        },
        //翻译 会员
        translateMember(){
            this.$axios.get('/getMemberInfos/TRANSLATE/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.tranMember = res.data.data.list
            })
        },
        // 人才 官方
        personOff(){
            this.$axios.get('/getOfficials/TALENT').then(res=>{

                this.personOfficial =res.data.data;
            })
        },
        //人才 会员
        personnelMember(){
            this.$axios.get('/getMemberInfos/TALENT/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.personMember = res.data.data.list
            })
        },
        //慈善 官方
        charOff(){
            this.$axios.get('/getOfficials/CHARITABLE').then(res=>{

                this.charOfficial =res.data.data;
            })
        },
        //慈善  会员
        charitableMember(){
            this.$axios.get('/getMemberInfos/CHARITABLE/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.charMember = res.data.data.list
            })
        },
        // 一带一路 官方
        theOff(){
            this.$axios.get('/getOfficials/YDYL').then(res=>{
                this.roadOfficial =res.data.data;
            })
        },
        // 一带一路  会员
        theMember(){
            this.$axios.get('/getMemberInfos/YDYL/'+this.page+'/'+this.pageSize).then(res=>{
                this.total = res.data.data.total;
                this.roadMember = res.data.data.list
            })
        },
        // 互助基金  官方
        culOff(){
            this.$axios.get('/getOfficials/FOUNDATION').then(res=>{

                this.culOfficial =res.data.data;
            })
        },
        // 互助基金 会员
        cultureMember(){
            this.$axios.get('/getMemberInfos/FOUNDATION/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.culMember = res.data.data.list
            })
        },
        //财务 官方
        finesOfficial(){
            this.$axios.get('/getOfficials/AFFAIRS').then(res=>{
                this.financeOfficial =res.data.data;
            })
        },
        //财务  会员
        finesMember(){
            this.$axios.get('/getMemberInfos/AFFAIRS/'+this.page+'/'+this.pageSize).then(res=>{
                this.total = res.data.data.total;
                this.finanMember = res.data.data.list
            })
        },
        // 政策官方
        polOff(){
            this.$axios.get('/getOfficials/POLICY').then(res=>{

                this.policyOfficial =res.data.data;
            })
        },
        // 政策 会员
        policyMember(){
            this.$axios.get('/getMemberInfos/POLICY/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.polMember = res.data.data.list
            })
        },
        // 投融资官方
        projectOff(){
            this.$axios.get('/getOfficials/PROJECTSHOW').then(res=>{

                this.projectOfficial =res.data.data;
            })
        },
        // 投融资 会员
        projectMember(){
            this.$axios.get('/getMemberInfos/PROJECTSHOW/'+this.page+'/'+this.pageSize).then(res=>{

                this.total = res.data.data.total;
                this.proMember = res.data.data.list
            })
        },

        //内容详情
        artDetails(id){
            this.$axios.get('/getArticalDetail/'+id).then(res=>{
                
                var reslist=res.data.data

                this.$router.push({ path: '/detail',query:{art:reslist}})
            })
        },

        //律师详情
        lawDetail(list){
            console.log(list)
            this.dialogFormVisible = true;
            this.lawObj = list;
        }
    },
}
</script>
<style scoped >
    .bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
       padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }
    .msg{
        width:100%;
        height:auto;
        margin-top:40px;
    }
    .leval{
        width:100%;
        height:100%;
    }
    .leval_left{
        float: left;
        width:14%;
        height:auto;
    }
    .leval_left ul{
        width: 100%;
        height:auto;
        border:1px solid #cecece;
    }
    .leval_left ul span{
        display:block;
        width:100%;
        height:auto;
        min-height:46px;
        font-size:20px;
        text-align:center;
        line-height:46px;
        color:#fff;
        background-color: #1f3358;
    }
    .leval_left ul li{
        width:90%;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px auto;
        border-radius: 6px;
        color:#1e3557;
        cursor:pointer;
        background-color: #ededed;
    }
    .leval_left ul li i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 10px 0 20px;
    }
    .leval_left ul li.num{
        background-color: #FE9900;
        color:#fff;
    }
    .leval_left ul li.active{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    .md_fwzx{
        width:100%;
        height:auto;
    }
    .md_fwzx ul{
        float: left;
        /* width:100%; */
        margin:0 auto;
        border:1px solid #ececec;
    }
    .md_fwzx ul span{
        display:block;
        width:100%;
        font-size:20px;
        text-align: center;
        line-height:46px;
        color:#fff;
        background-color: #1e3557;
    }
     .md_fwzx ul li{
        float: left;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px 10px;
        border-radius: 6px;
        color:#1e3557;
        box-sizing: border-box;
        padding:0 10px;
        cursor:pointer;
        background-color: #ededed;
    }
    .md_fwzx ul i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 4px 0 4px;
    }
    .md_fwzx ul li.Act{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    .leval_right{
        float:left;
        width:80%;
        height:auto;
        min-height:500px;
        margin-left:14px;
        background-color: #f8f8f8;
    }
    .leval_right div{
        box-sizing: border-box;
        padding:10px 10px;
    }
    

  .leval_right ul li{
      font-size:18px;
      color:#333;
  }


    /* 律师 */
    .lawyer{
        width:100%;
        height:auto;
    }
    .lawyer span{
        display:block;
        font-size:22px;
        margin:10px 0;
        color:#333;
        font-weight: 600;
    }
    
    .lawyer ul {
        float: left;
        width:23%;
        min-width:200px;
        height:auto;
        /* min-height:400px; */
        margin:10px 10px 10px 0;
        border:1px solid #eee;
        border-radius: 10px;
    }
    .lawyer ul:hover{
        box-shadow: 0 0 10px #999;
        transform: scale(1.1);
    }
    
    .lawyer ul li,h3{
        /* margin-left:10px; */
        /* margin-top:10px; */
        box-sizing: border-box;
        padding:10px 10px 10px 10px;
        
    }
    .lawyer ul li img{
        display:block;
        width:100%;
        height:280px;
    }
    /* .lawyer ul li img:hover{
        transform: scale(1.1);
    } */
    
    .lawyer ul .lawyer_name{
        color:#333;
        cursor: default;
    }
    .lawyer ul .lawyer_phone{
        color:#666;
        cursor: default;
    }
    .lawyer ul .lawyer_dis{
        color:#999;
        min-height:200px;
         text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        cursor: default;
    }

    /* 官方 */
    .official{
        width: 100%;
        height:500px;
        clear:both;
        /* border-top:1px dashed #dddddd; */
        border-bottom:1px dashed #dddddd;
    }
    .official span{
        display:block;
        font-size:22px;
        margin:10px 0;
        color:#333;
        font-weight:600;
    }
    .official .listgffb{
        width: 100%;
        height:400px;
        min-height:400px;
        overflow-y:auto;
    }
    .listgffb ul{
        width:100%;
        height:auto;
        min-height:200px;
        
    }
    .listgffb ul li{
        margin:10px 0;
        /* box-sizing: border-box; */
        /* padding:10px 0 0 10px; */
    }
    .listgffb ul li img{
        float:left;
        display:block;
        width:240px;
        height:180px;
        margin-right:10px;
    }
    .listgffb ul .off_title{
        font-size:22px;
        font-weight:600;
        color:#333;
        cursor: default;
    }
    .listgffb ul .off_time{
        font-size:14px;
        color:#666;
        cursor: default;
    }
    .listgffb ul .off_msg{
        font-size:18px;
        color:#999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: box;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        cursor: default;
    }

    .listgffb .top{
        display: inline;
        font-size:14px;
        color:#fff;
        background-color: #fe9900;
    }
    /* 会员 */
    .memuse{
        width:100%;
        height:auto;
        clear:both;
    }
    .memuse span{
        display:block;
        font-weight: 600;
        font-size:22px;
        margin:10px 0;
        color:#333;
    }
    .memuse ul li {
        font-size:18px;
        font-weight:600;
        color:#767676;
        /* margin:10px 0 ; */
        box-sizing: border-box;
        padding-bottom:20px;
        border-bottom:1px solid #dddddd;
        margin:20px 0;
        cursor: pointer;
    }
    .memuse ul li span{
        font-weight:normal;
        font-size:14px;
        color:#999;
    }
    .memuse ul li strong{
         width:50px;
        height:20px;
        font-size:14px;
        color:#fff;
        background-color: #fe9900;
    }
    .memuse ul li.change{
        color:#ff9900;
    }
    #page-break{
        float:left;
    }

    /* 服务项目简介 */
    .project{
        width:100%;
        height:auto;
        box-sizing: border-box;
        padding-bottom:20px;
        text-align: justify;
        border-bottom:1px solid #ddd;
    }
    .project .project_item{
        display:block;
        font-size:22px;
        color:#333;
        font-weight:bold;
        margin-bottom:8px;
    }
    .project p{
        font-size:21px;
        color:#666;
        margin-bottom:6px;
    }

   
</style>

<style>
    .el-dialog{
        height:1000px;
        left:100px;
    }
    .el-dialog__body{
        font-size:22px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ZH-CN/levalPage.vue